import script from "./register.vue?vue&type=script&setup=true&lang=js"
export * from "./register.vue?vue&type=script&setup=true&lang=js"

import "./register.vue?vue&type=style&index=0&id=50f3d4cb&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\rcpetresort.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f3d4cb"]])

export default __exports__